var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { h, Component } from 'preact';
import { isMobile, inContext, dispatchGlobalEvent, } from '../../services/UtilsTool';
var WatchClickOutside = /** @class */ (function (_super) {
    __extends(WatchClickOutside, _super);
    function WatchClickOutside(props) {
        var _this = _super.call(this, props) || this;
        _this.componentDidUpdate = function (event) {
            _this.calcHeight();
        };
        _this.onOutsideClick = function (event) {
            if (_this.wrapperRef && !_this.wrapperRef.contains(event.target)) {
                _this.props.handleClick('closed');
            }
        };
        _this.calcHeight = function () {
            if (_this.wrapperRef && _this.state.height !== _this.wrapperRef.clientHeight) {
                _this.setState({
                    height: _this.wrapperRef.clientHeight,
                });
                dispatchGlobalEvent('srwrdsHeight', _this.state.height + 15);
            }
        };
        return _this;
    }
    WatchClickOutside.prototype.componentDidMount = function () {
        // This component should not care about this what CASINO is. The event type should be passed in as props.
        if (inContext('CASINO')) {
            this.eventType = 'mouseup';
        }
        else if (isMobile) {
            this.eventType = 'touchstart';
        }
        if (this.eventType) {
            document.addEventListener(this.eventType, this.onOutsideClick);
        }
        this.calcHeight();
    };
    WatchClickOutside.prototype.componentWillUnmount = function () {
        document.removeEventListener(this.eventType, this.onOutsideClick);
    };
    WatchClickOutside.prototype.render = function () {
        var _this = this;
        return (h("div", { ref: function (node) { return (_this.wrapperRef = node); }, onClick: this.calcHeight }, this.props.children));
    };
    return WatchClickOutside;
}(Component));
export default WatchClickOutside;
